// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa9cd6d4","833":"9cb4dfba"}[chunkId] + ".chunk.js";
};